import { useContext } from 'react';
import { ShotsContext } from 'packages/contexts/ShotsContext';
import shotDefault from '../../src/assets/images/shot.png';

export function useShots() {
    return useContext(ShotsContext) as any;
}

export default function useShot(index: number) {
    const { shots, shotsImages } = useContext(ShotsContext) as any;

    return {
        shot: shots[index],
        image: shotsImages[index] || shotDefault,
    };
}
